import i18n from "i18next";
import { type FC, useCallback } from "react";
import { useNavigate } from "react-router";

import { SecondaryButton } from "../Buttons/components/ActionButton";

export type BackButtonProps = {
    isDisabled: boolean;
    url: string;
    onBeforeNavigate?: () => void;
};

export const BackButton: FC<BackButtonProps> = ({ isDisabled, url, onBeforeNavigate }) => {
    const navigate = useNavigate();
    const callback = useCallback(() => {
        if (onBeforeNavigate) onBeforeNavigate();
        navigate(url);
    }, [navigate, onBeforeNavigate, url]);

    return (
        <SecondaryButton name="go_back" onClick={callback} disabled={isDisabled}>
            {i18n.t("button.back")}
        </SecondaryButton>
    );
};
